import { Component, ElementRef, Inject, Injector, AfterViewInit } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from '../../../services/AppComponentBase';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from "../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component";
import { OrderRs, CancelRs, ITournamentRegisterRs } from '../../../interfaces/service.response';
import { ICompetitionData } from '../../../interfaces/IcompetitionData';
import { TournamentRegister } from "../../../model/tournament";
import { Tournament, TournamentWithAccountId } from "../../../api/DixApiClient";
import { ShowCompetitionRegisterModal } from "./show-competition-registration-modal";
import { Utils } from "../../../utils";


@Component({
    selector: "modal-CompetitionRegistration",
    template: require('./competitionRegistration.component.html'),
    styles: [require('./competitionRegistration.component.css')]
})

export class competitionRegistrationModal  extends AppComponentBase implements AfterViewInit   {

   
    constructor(
        protected router: Router,
        protected fb: FormBuilder,
        public activeModal: NgbActiveModal,
        public dataService: DataService,
        injector: Injector,
    ) {
        super(injector);

        this.dataService.dataSubscriber.subscribe(response => {

            if(response.Type == "TournamentRegisterRs")
            {
                let registerRs = <ITournamentRegisterRs>response;
             //   registerRs.Error="";
           //   registerRs.Error = "";
                if(registerRs.Error!="")
                {
                    this.showButtons = true;
                    this.showError = true;
                    this.errorMessage= registerRs.Error;
                }
                else
                {
                    
                    if(!this.funnelLogin)
                    {
                         this.activeModal.close();
                    }
                   
                    if(!this.workspace.funnelLoginWindow)
                    {

                        if(!this.workspace.activeFirstLogin)
                        {
                              console.log(this.competition);
                    // if(this.funnelLogin!=true)
                    //    {
                            if(this.workspace.currentRegisteringChallenge!=undefined)
                            ShowCompetitionRegisterModal(this.modalService, this.workspace.currentRegisteringChallenge, false, false,false,true, undefined, this.workspace.mobileMode);
                //     }
                        }
                      
                    }
                        this.workspace.wasLoginByTournamentUser(this.workspace.userId, this.competition!.id,1);
                        this.workspace.loadTournamentAndSetUser();
                        this.workspace.activeFirstLogin = true;
                }
            }
            
        })

        this.globaGridMode.loadedTournaments.subscribe((v)=>{
    
            
            this.upcomingTournaments  = this.workspace.upcomingTournaments;
         
          })
      

    }

    public _upcomingTournaments: Tournament[] = [];
    public get upcomingTournaments (): Tournament[] {
        return this._upcomingTournaments;
    }
    public set upcomingTournaments ( value: Tournament[] ) {
        this._upcomingTournaments = value;
    }

    private _showError: boolean = false;
    public get showError (): boolean {
        return this._showError;
    }
    public set showError ( value: boolean ) {
        this._showError = value;
    }


    private _errorMessage: string = "ERROR";
    public get errorMessage (): string {
        return this._errorMessage;
    }
    public set errorMessage ( value: string ) {
        this._errorMessage = value;
    }

    private _FirstName: string = "";
    public get FirstName (): string {
        return this._FirstName;
    }
    
    private _LastName: string = "";
    public get LastName (): string {
        return this._LastName;
    }
   

    public rememberch = false;
    public isAccepted() {
        this.rememberch = !this.rememberch;
    }

    private _hideButtons: boolean = true;
    public get showButtons (): boolean {
        return this._hideButtons;
    }
    public set showButtons ( value: boolean ) {
        this._hideButtons = value;
    }

    private _competition: TournamentWithAccountId | null= null;
    public get competition (): TournamentWithAccountId | null {
        return this._competition;
    }
    public set competition ( value: TournamentWithAccountId | null) {
        this._competition = value;
    }


    public get AgreementURL(): string | null | undefined 
    {
        return this.competition!.agreementUrl;
    }

    private _isViewDetails: boolean = false;
    public get isViewDetails (): boolean {
        return this._isViewDetails;
    }
    public set isViewDetails ( value: boolean ) {
        this._isViewDetails = value;
    }
    

    private _successMessage: boolean = false;
    public get successMessage (): boolean {
        return this._successMessage;
    }
    public set successMessage ( value: boolean ) {
        this._successMessage = value;
    }

    public funnelImage:string = '<img style="width:100%" src="/images/challenges/funnel-image.png">';

    public allowFunnelAction()
    {
        setTimeout(() => {
             this.workspace.allowFunnelAction = true;
        }, 100);
       
       this.workspace.funnelLoginWindow = true;
    }

    register()
    { 
        // console.log("REGISTER COMPETITION")
        // console.log([this.workspace.activeAccountId, this.competition] )

        this.showButtons = false;

        let tournamentAccountData = new TournamentRegister();

        if(this.competition!=null)
        {
             tournamentAccountData.TournamentId = this.competition.id;
             this.workspace.currentRegisteringChallenge = this.competition;
        }
       

        this.dataService.sendRequest(
            {
                Cmd: DataService.TYPE_TOURNAMENTREGISTER,
                Data: tournamentAccountData
            }
        )

      //  this.activeModal.close();
    }

    private _isUser: boolean = false;
    public get isUser (): boolean {
        return this._isUser;
    }
    public set isUser ( value: boolean ) {
        this._isUser = value;
    }

    private _competitionDetails: string | null | undefined = "";
    public get competitionDetails (): string | null | undefined {
        if(this.competition!=null)
        {
         return this.competition.viewDetails!.replace(".png", this.replacePngWithVersion);
        }
    }
    public set competitionDetails ( value: string | null | undefined ) {
        this._competitionDetails = value;
    }


    public get competitionRules (): string | null | undefined {
        if(this.competition!=null)
        {
         return this.competition.rulesUrl
        }
    }

    private _funnelLogin: boolean = false;
    public get funnelLogin (): boolean {
        return this._funnelLogin;
    }
    public set funnelLogin ( value: boolean ) {
        this._funnelLogin = value;
       // this.workspace.funnelLoginWindow = value;
        if(value==true)
        {
            // $(".upcoming-list").mCustomScrollbar({
            //     axis: "y",
            //     theme: "inset-3", // "minimal-dark",
            //     scrollbarPosition: "outside",
            //     alwaysShowScrollbar: 1, // 0,1,2
            //     scrollButtons: {
            //         enable: true
            //     },
            //     mouseWheel: {
            //         enable: true
            //     }
            // });
        }
    }


    public checkActiveTournament()
    {
        let checkCurrent = this.workspace.currentTournaments.filter(v=>{
            return v.id == this.competition!.id;
        })
       
        if(checkCurrent.length>0)
        {
            window.location.href="/";
        }

    }





    private _firstLogin: boolean = false;
    public get firstLogin (): boolean {
        return this._firstLogin;
    }
    public set firstLogin ( value: boolean ) {
        this._firstLogin = value;
    }

    private _dismissWindow: boolean = false;
    public get dismissWindow (): boolean {
        return this._dismissWindow;
    }
    public set dismissWindow ( value: boolean ) {
        this._dismissWindow = value;
    }


    private _replacePngWithVersion: string = ".png?ver=";
    public get replacePngWithVersion (): string {
        return this._replacePngWithVersion + this.workspace.buildNumber;
    }
    public set replacePngWithVersion ( value: string ) {
        this._replacePngWithVersion = value;
    }

    public get firstLoginImage (): string | null | undefined{
        if(this.competition!=null)
        {
         return this.competition.firstLoginImage!.replace(".png", this.replacePngWithVersion);
        }
    }
    
    public showDismissRegistrationModal()
    {
        ShowCompetitionRegisterModal(this.modalService, this.competition, false, false, false, false, true, this.workspace.mobileMode);
    }


    public resignAction()
    {
     //   alert("RESIGN" + this.competition!.id + this.workspace.userId);
        this.activeModal.close();
        this.workspace.deleteTournamentsForUser(this.workspace.userId,this.competition!.id)
        .then(response => {
            if (response !== null) {
                this.workspace.loadTournamentAndSetUser();
                this.modalService.dismissAll();
            }
        }).catch(error => {
            console.error(error);
        })

    }



    ngAfterViewInit(): void {
        this.initScroll()
    }

    public initScroll()
    {
        $(".details-data").mCustomScrollbar({
            axis: "y",
            theme: "inset-3", // "minimal-dark",
            scrollbarPosition: "outside",
            alwaysShowScrollbar: 1, // 0,1,2
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                enable: true
            }
        });

       
    }



    public showCompeteRegistrationModal()
    {
      ShowCompetitionRegisterModal(this.modalService, this.competition, undefined, undefined, undefined, undefined, undefined, this.workspace.mobileMode);
    }

    public openPopup(myURL:any, title:any, myWidth:any, myHeight:any) 
    {
        Utils.openPopup(myURL, title, myWidth, myHeight);
    }


    

}
